import { SimulationCanvas } from './components/SimulationCanvas';
import { ControlPanel } from './components/ControlPanel';
import './App.css';

function App() {
  return (
    <div className="app">
      <div className="simulation-container">
        <SimulationCanvas />
      </div>
      <ControlPanel />
    </div>
  );
}

export default App; 